<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="bg-primary h-full flex items-center justify-center"
        style="width: 35vw; color: white; font-weight: bold; font-size: 1.5rem"
        to="/"
        aria-label="Visit homepage"
      >
        ED-EX Admin
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <RouterLink class="py-4 logo-mobile" to="/" aria-label="Visit homepage">
              ED-EX Admin
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import VuesticLogo from '../components/VuesticLogo.vue'

const breakpoint = useBreakpoint()
</script>

<style>

.logo-mobile {
  color: var(--va-primary);
  font-weight: bold;
  font-size: 1.5rem
}

.logo-mobile {
  color: var(--va-primary);
  font-weight: bold;
  font-size: 1.5rem
}
</style>
